export default __webpack_public_path__ + "static/media/SEPTDOM2026.bac81899.png";